<template>
  <div class="ProductSubjectToolModal">
    <el-dialog
        :title="title"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="80%"
    >
      <el-form ref="form" :model="formData" label-width="90px">
        <el-form-item label="学习周期:">
          <el-input-number
              v-model="formData.day"
              :precision="0"
              :step="1"
              :min="1"
              @change="dayChange"
          ></el-input-number>
          天
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "ProductSubjectToolModal",
  props: {},
  data() {
    return {
      title: "",
      visible: false,
      formData: {
        day: 1
      }
    };
  },
  computed: {},
  methods: {
    initData(data) {
      this.formData = data;
      if (data.duration)
        this.formData.day = data.duration / 86400000;
      this.title = data.classSubjectName;
    },
    dayChange(value) {
      if (value)
        this.formData.duration = value * 86400000
    }
  },
};
</script>

<style lang="scss" scoped>
.ProductSubjectToolModal {

}
</style>
